export default {
  ruleSet: {
    ruleSet: "Rule Set",
    ruleSetCode: "Mã Rule Set",
    ruleSetName: "Tên Rule Set",
    ruleSetType: "Loại Rule Type",
    collectionTarget: "Bảng dữ liệu",
    usageCheck: "Sử dụng",
    riskLevel: "Mức độ nguy hiểm",
  }
};
